import { Box, styled } from '@mui/material';

export const PopOverBox = styled(Box)`
  border-radius: 8px;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

export const PopOverBoxHeader = styled(Box)`
  border-bottom: 1px solid #e7e9ec;
  background: rgba(249, 250, 251, 0.9);
  backdrop-filter: blur(6px);
  padding: 12px 16px 12px 20px;

  color: #000;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PopOverBoxInner = styled(Box)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000;
  background: #fff;
  ul {
    margin: 0;
    padding-inline-start: 18px;
    li::marker {
      font-size: 10px;
    }
  }
`;
